var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.09 5.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bfd3ec;\n      }\n\n      .cls-2 {\n        fill: #43a047;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2.54 0 3.27 .44 4.12 .51 4.45 1.29 5.09 1.85 4.9 2.68 5.09 3.5 4.45 4.06 4.12 4.84 3.27 4.92 2.54 5.35 1.82 4.92 .97 4.84 .64 4.06 0 3.5 .19 2.68 0 1.85 .64 1.29 .97 .51 1.82 .44 2.54 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2.06 3.87 1.14 2.95 1.62 2.46 2.06 2.9 3.46 1.48 3.95 1.96 2.06 3.87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.49495b0bf3e23aabc2a3b38144b60d0a.svg";
export { ForwardRef as ReactComponent };